import { useRef } from 'react';
import { Spinner } from './spinner.component';

interface ButtonProp {
  label: string
  isLoading?: boolean
  disable?: boolean
  type?: 'button' | 'submit' | 'reset'
  action?: () => void
  onChange?: () => void
};

export const Button = ( { label, type, isLoading = false, disable = false, action, onChange }: ButtonProp ) => {

  const buttonRef = useRef<HTMLButtonElement>( null );
  const onClick = () => {
    if ( action !== undefined ) {
      action();
    }
    if ( buttonRef.current ) {
      const animation = [
        { transform: 'scale(1)' },
        { transform: 'scale(0.95)' },
        { transform: 'scale(1)' },
      ];
      const timing = {
        duration: 250,
        iterations: 1,
      };
      buttonRef.current.animate( animation, timing );
    }
  };

  return (
    <button
      type={type ?? 'button'}
      ref={buttonRef}
      className={
        'w-full h-full px-2 py-1 rounded-md border bg-tertiary shadow text-white ' +
        ( isLoading ? 'bg-tertiary-dark ' : '' ) +
        ( disable ? 'bg-slate-300 ' : 'hover:bg-tertiary-dark ' )
      }
      onClick={ onClick }
      onChange={ onChange }
      disabled={ isLoading || disable }
    >
      <div className='flex h-full justify-center'>
        {
          isLoading ?
            <Spinner />
            :
            <p className='text-base self-center'>
              {label}
            </p>
        }
      </div>
    </button>
  );
};